export enum EventAuditEnum {
  CREATED = 'created',
  UPDATED = 'updated',
  DELETED = 'deleted',
  RESTORED = 'restored',
}

export enum TimezoneCode {
  KALININGRAD = 'Europe/Kaliningrad', // UTC+2
  MOSCOW = 'Europe/Moscow', // UTC+3
  SAMARA = 'Europe/Samara', // UTC+4
  YEKATERINBURG = 'Asia/Yekaterinburg', // UTC+5
  OMSK = 'Asia/Omsk', // UTC+6
  KRASNOYARSK = 'Asia/Krasnoyarsk', // UTC+7
  IRKUTSK = 'Asia/Irkutsk', // UTC+8
  YAKUTSK = 'Asia/Yakutsk', // UTC+9
  VLADIVOSTOK = 'Asia/Vladivostok', // UTC+10
  MAGADAN = 'Asia/Magadan', // UTC+11
  KAMCHATKA = 'Asia/Kamchatka', // UTC+12
}

export enum FuelTypeEnum {
  AI100 = 'AI100',
  AI92 = 'AI92',
  AI95 = 'AI95',
  AI98 = 'AI98',
  DIESEL = 'DIESEL',
  METHANE = 'METHANE',
  PROPANE = 'PROPANE',
  ELECTRICITY = 'ELECTRICITY',
}

export enum CategoryAutoEnum {
  ECONOMY = 'ECONOMY',
  COMFORT = 'COMFORT',
  COMFORT_PLUS = 'COMFORT_PLUS',
  BUSINESS = 'BUSINESS',
  COMFORT_LOWER_CASE = 'COMFORT_LOWER_CASE',
  ECONOMY_LOWER_CASE = 'ECONOMY_LOWER_CASE',
  COMFORT_PLUS_LOWER_CASE = 'COMFORT_PLUS_LOWER_CASE',
  COMFORT_PLUS_SECOND = 'COMFORT_PLUS_SECOND',
}

export enum TransmissionEnum {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL',
}
